module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Flower1-25f566879170918c6c0c788b52502a38.svg";